// Core imports
import React, { useCallback } from 'react';

// Component imports
import { Button, Badge, Row, Col, Dropdown, Divider, Avatar, Space, Empty, Typography } from 'antd';
import { Notification, Send } from 'react-iconly';

// Misc imports
import { NAV_NDES_EDIT, NAV_RELATIVE_NDES_BASIC_DETAILS, STORAGE_KEYS } from '../../../constants';
import { useNavigate } from 'react-router-dom';
import replaceUrlParams from '../../../utils/misc/replaceUrlParams';

// Constant declarations
const { Text } = Typography;

export default function HeaderNotifications() {
  const navigate = useNavigate();

  const getUserNdes = useCallback(() => {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEYS.OWN_NDE_UUIDS)) || [];
  }, [window.localStorage.getItem(STORAGE_KEYS.OWN_NDE_UUIDS)]);

  const notificationMenu = (
    <div className="py-16 bg-color-black-0 bg-color-dark-100 border-color-black-40 border-color-dark-80 border-radius border-1">
      <div className="px-16">
        <Row align="middle" justify="space-between">
          <Col className="p1-body font-weight-500 text-color-black-100 text-color-dark-10 text-color-dark-0 mr-64">
            Notifications
          </Col>

          {
            getUserNdes().length > 0 ? (
              <Col className="bg-color-primary-1 border-radius-full badge-text text-color-black-0 py-4 px-6 ml-24">
                {getUserNdes().length} New
              </Col>
            ) : null
          }
        </Row>
      </div>

      <Divider className="my-16 mx-0 bg-color-black-40 bg-color-dark-80" />

      {
        getUserNdes().length > 0 ? (
          <Space
            size={0}
            direction="vertical"
            split={<Divider className="my-16 mx-0 bg-color-black-40 bg-color-dark-80" />}
            className="w-100"
          >
            {
              getUserNdes().map((ndeUuid, index) => (
                <div className="px-16">
                  <Row
                    align="middle"
                    key={index}
                    onClick={() => navigate(replaceUrlParams((NAV_NDES_EDIT + NAV_RELATIVE_NDES_BASIC_DETAILS), { ndeUuid: ndeUuid }))}
                    className="cursor-pointer"
                  >
                    <Col className="mr-12">
                      <Avatar size={32} icon={<Send size={17} className="text-color-primary-1 remix-icon" style={{ fontSize: 12 }} />} className="d-flex-center-full" />
                    </Col>

                    <Col>
                      <span className="d-block w-100 mb-4 badge-text font-weight-500 text-color-black-100 text-color-dark-10">
                        NDE Submitted
                      </span>

                      <span className="d-block input-description font-weight-500 text-color-black-80 text-color-dark-40">
                        Access it by clicking here!
                      </span>
                    </Col>
                  </Row>
                </div>
              ))
            }
          </Space>
        ) : (
          <Row align="middle">
            <Col span={24}>
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    No new notifications
                  </Text>
                }
              />
            </Col>
          </Row>
        )
      }
    </div>
  );

  return (
    <Col className="d-flex-center mr-sm-12 mr-16">
      <Button
        type="text"
        icon={
          <Dropdown overlay={notificationMenu} placement="bottomRight">
            <div className="position-relative">
              {
                getUserNdes().length > 0 ? (
                  <div className="position-absolute" style={{ left: -5, top: -5 }}>
                    <Badge
                      dot
                      status="processing"
                    />
                  </div>
                ) : null
              }

              <Notification
                set="curved"
                className="text-color-black-60"
              />
            </div>
          </Dropdown>
        }
      />
    </Col>
  );
}
